/* Progressive scroll depth. Sticky positioning stays native; no scroll hijacking. */
if (!customElements.get('zb-product-showcase')) {
  customElements.define('zb-product-showcase', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.cards = [...this.querySelectorAll('[data-zb-showcase-card]')];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.stacking = matchMedia('(min-width: 990px) and (min-height: 800px)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.classList.add('zb-showcase-enhanced');
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (this.visible) this.schedule();
      }, { rootMargin: '80px' });
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => this.schedule());
      this.resize.observe(this);
      addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      addEventListener('resize', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.reset(), options);
      this.stacking.addEventListener('change', () => this.reset(), options);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Tab') document.body.classList.add('zb-showcase-keyboard');
      }, options);
      document.addEventListener('pointerdown', () => document.body.classList.remove('zb-showcase-keyboard'), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.cancel();
        else this.schedule();
      }, options);
    }
    schedule() {
      if (this.frame || !this.visible || document.hidden || this.motion.matches) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
    }
    update() {
      const bounds = this.cards.map((card) => card.getBoundingClientRect());
      this.cards.forEach((card, index) => {
        const top = 106 + index * 18;
        const next = bounds[index + 1];
        const overlap = this.stacking.matches && next ? Math.min(1, Math.max(0, 1 - (next.top - top) / bounds[index].height)) : 0;
        card.style.setProperty('--zb-showcase-scale', (1 - overlap * .025).toFixed(4));
        const depth = Math.max(-16, Math.min(16, (innerHeight / 2 - bounds[index].top) * .025));
        card.style.setProperty('--zb-showcase-parallax', `${depth.toFixed(2)}px`);
      });
    }
    cancel() { cancelAnimationFrame(this.frame); this.frame = 0; }
    reset() {
      this.cancel();
      this.cards?.forEach((card) => {
        card.style.removeProperty('--zb-showcase-scale');
        card.style.removeProperty('--zb-showcase-parallax');
      });
      this.schedule();
    }
    disconnectedCallback() {
      this.events?.abort(); this.observer?.disconnect(); this.resize?.disconnect(); this.cancel();
      this.classList.remove('zb-showcase-enhanced');
    }
  });
}
